import { LEGAL_PATHS } from './components/legal/utils/legalPaths';

// STORE CONSTANTS

export const USER = {
  UPDATE_USER_DETAILS: 'UPDATE_USER_DETAILS',
};

export const MENU = {
  TOGGLE_MENU: 'TOGGLE_MENU',
  TOGGLE_CATCH_REPORT: 'TOGGLE_CATCH_REPORT',
  TOGGLE_AP_CROSSING: 'TOGGLE_AP_CROSSING',
  UPDATE_MENU_REF: 'UPDATE_MENU_REF',
};

export const LAKE_MANAGER = {
  UPDATE_SERVICE_TYPE: 'UPDATE_SERVICE_TYPE',
};

export const ADMIN_ROLES = {
  ADMIN: 'admin',
  STAFF: 'staff',
  BAILIFF: 'bailiff',
};

export const ADMIN_LOGOUT_ACTION = 'admin/log_out';
export const EVENT_ADMIN_LOGOUT_ACTION = 'eventadmin/logout';
export const SET_PRINTER_ACTION = 'admin/set_printer';

export const PRIVACY_POLICY_URL = LEGAL_PATHS.PRIVACY_POLICY;
export const TERMS_AND_CONDITIONS_URL = LEGAL_PATHS.ANGLER_TERMS;

export const OPS_ADMIN_URL = '/sb/admin';

export const PRODUCTION_SITE_URL = 'https://swimbooker.com';

export const SUPPORT_EMAIL = 'support@swimbooker.com';
export const INFO_EMAIL = 'info@swimbooker.com';
export const HELP_CENTRE_URL =
  'https://145784441.hs-sites-eu1.com/sb-support-hub';

export const SWIMBOOKER_APP_STORE_URL =
  'https://apps.apple.com/gb/app/swimbooker/id1586855906';
export const SWIMBOOKER_GOOGLE_PLAY_URL =
  'https://play.google.com/store/apps/details?id=com.app.swimbookerapp';
export const WATERCRAFT_URL = 'https://watercraft.app';
export const TRUSTPILOT_REVIEW_URL =
  'https://uk.trustpilot.com/review/www.swimbooker.com';

export const SOCIAL_LINKS = {
  FACEBOOK: 'https://www.facebook.com/swimbookerUK',
  INSTAGRAM: 'https://www.instagram.com/swimbookeruk/',
  X: 'https://x.com/swimbooker',
  YOUTUBE: 'https://www.youtube.com/@swimbookerUK',
  TIKTOK: 'https://www.tiktok.com/@swimbooker',
};

export const COMPANY_DETAILS = {
  LEGAL_NAME: 'swimbooker Limited',
  COMPANY_NUMBER: '12915151',
  REGISTERED_IN: 'England and Wales',
  STREET_ADDRESS: '4th Floor, Silverstream House, 45 Fitzroy Street',
  LOCALITY: 'London',
  POSTCODE: 'W1T 6EB',
  VAT_NUMBER: 'GB 359938336',
};
